const ALLOWED_PATTERNS = new Set([
  'PROGRESSIVE_REVEAL',
  'BUILD_UP_CONSTRUCTION',
  'STEP_EXECUTION',
  'STATE_TRANSITION',
  'DEPENDENCY_PROPAGATION',
  'VALUE_ACCUMULATION',
  'FOCUS_SHIFT',
  'STRUCTURAL_TRANSFORMATION',
  'MORPHING',
  'SIMULATION_LOOP',
  'PARALLEL_COMPARISON',
  'COUNTEREXAMPLE_REVEAL',
  'PATH_TRACING',
  'COLLAPSE_EXPAND',
  'ENERGY_FLOW_SIMULATION',
  'GRAPH_TRAVERSAL',
  'DP_FILL',
]);

function clamp01(v) {
  return Math.max(0, Math.min(1, Number.isFinite(v) ? v : 0));
}

export function normalizePedagogicalPattern(rawPattern) {
  const normalized = String(rawPattern || '')
    .trim()
    .toUpperCase();
  return ALLOWED_PATTERNS.has(normalized) ? normalized : '';
}

export function derivePatternState({ pattern, progress, timeSec, durationSec, totalItems }) {
  const p = clamp01(progress);
  const total = Math.max(1, Number.isFinite(totalItems) ? totalItems : 1);
  const duration = Math.max(0.001, Number.isFinite(durationSec) ? durationSec : 1);
  const t = Math.max(0, Number.isFinite(timeSec) ? timeSec : 0);

  const base = {
    pattern,
    progress: p,
    visibleCount: Math.max(1, Math.ceil(total * p)),
    focusIndex: Math.max(0, Math.min(total - 1, Math.floor(total * p))),
    emphasisPulse: 0.82 + 0.18 * Math.sin((t / duration) * Math.PI * 6),
    valueScale: p,
    morphMix: p,
  };

  switch (pattern) {
    case 'STEP_EXECUTION':
    case 'DP_FILL':
      return {
        ...base,
        visibleCount: Math.max(1, Math.floor(total * p)),
      };
    case 'FOCUS_SHIFT':
      return {
        ...base,
        visibleCount: total,
      };
    case 'VALUE_ACCUMULATION':
      return {
        ...base,
        visibleCount: total,
        valueScale: p,
      };
    case 'STRUCTURAL_TRANSFORMATION':
    case 'MORPHING':
      return {
        ...base,
        visibleCount: total,
        morphMix: p,
      };
    case 'PROGRESSIVE_REVEAL':
    case 'BUILD_UP_CONSTRUCTION':
    case 'GRAPH_TRAVERSAL':
    case 'PATH_TRACING':
    case 'DEPENDENCY_PROPAGATION':
      return base;
    default:
      return base;
  }
}

export function itemAlphaForFocus(patternState, itemIndex) {
  if (!patternState || patternState.pattern !== 'FOCUS_SHIFT') return 1;
  return itemIndex === patternState.focusIndex ? 1 : 0.34;
}

export const pedagogicalPatternVocabulary = {
  allowed: Array.from(ALLOWED_PATTERNS),
};
